export default __webpack_public_path__ + "static/media/vista-master-plan.e9f0b99c.pdf";